import type { Vfs, OpenFile } from '@mimir/common/types/vfs';
import type { IpcVfs } from '@mimir/common/types/ipcVfs';

// This is a basic wrapper for the IpcVfs to conform with the Vfs interface.
// It is meant to be applied when in the electron context that the vfs will
// be used from.
// For more information see the comment above the IpcVfs interface definition.

export function createIpcVfsWrapper(ipcVfsInternal: IpcVfs): Vfs {
  const internal = ipcVfsInternal;
  return {
    async open(path: string, flags: string): Promise<OpenFile> {
      const internalOpenFile = await internal.open(path, flags);
      return {
        async read(buf: Uint8Array, bufOffset: number, count: number, fileOffset: number): Promise<number> {
          // The buffer reference does not make it across the context bridge, so instead we have to get
          // the buffer as a return value to get the data
          const data: Uint8Array = await internalOpenFile.read(count, fileOffset);
          if (data.length + bufOffset > buf.length) {
            throw new Error('Buffer out of range');
          }
          buf.set(data, bufOffset);
          return data.length;
        },
        write: internalOpenFile.write,
        close: internalOpenFile.close,
      };
    },
    openDir: internal.openDir,
    rename: internal.rename,
    stat: internal.stat,
    unlink: internal.unlink,
    mkdir: internal.mkdir,
    rmdir: internal.rmdir,
  };
}
